export default {
	home: 'Kezdőoldal',
	contact: 'Kontakt',
	dummyData: 'Dummy adat',
};
